import {CloudIcon, ContainerIcon, ServerIcon, type Icon} from '@primer/octicons-react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {TrailingVisualSlotProps} from '../agent-profile-types'
import styles from '../../components/AgentTypeTrailingVisual.module.css'

/**
 * Default trailing visual for cloud-based agents.
 * Renders a CloudIcon, FF-gated behind copilot_mission_control_session_filters.
 */
export function DefaultTrailingVisual(_props: TrailingVisualSlotProps) {
  return <SessionTypeTrailingVisual icon={CloudIcon} label="Cloud session" testId="agent-type-trailing-visual-cloud" />
}

export function EnvironmentTrailingVisual(_props: TrailingVisualSlotProps) {
  return (
    <SessionTypeTrailingVisual
      icon={ServerIcon}
      label="Environment session"
      testId="agent-type-trailing-visual-environment"
    />
  )
}

export function SandboxTrailingVisual(_props: TrailingVisualSlotProps) {
  return (
    <SessionTypeTrailingVisual
      icon={ContainerIcon}
      label="Sandbox session"
      testId="agent-type-trailing-visual-sandbox"
    />
  )
}

function SessionTypeTrailingVisual({icon: IconComponent, label, testId}: {icon: Icon; label: string; testId: string}) {
  if (
    !isFeatureEnabled('copilot_mission_control_session_filters') ||
    !isFeatureEnabled('copilot_mission_control_environment_list_icons')
  ) {
    return null
  }

  return (
    <span className={styles.wrapper} role="img" aria-label={label} data-testid={testId}>
      <IconComponent />
    </span>
  )
}
